import {memo, PropTypes, propTypesExact, shapeComponent, ShapeComponent, Text, View} from "shared/base"
import Icon from "@kaspernj/api-maker/build/utils/icon"
import Link from "@kaspernj/api-maker/build/link"
import React from "react"

const inactiveColor = "#87a2d5"
const activeColor = "#5253ff"

export default memo(shapeComponent(class ComponentsChalkyLayoutMenuItem extends ShapeComponent {
  static defaultProps = {
    active: false,
    iconVersion: undefined,
    identifier: null,
    onPress: null,
    to: null
  }

  static propTypes = propTypesExact({
    active: PropTypes.bool,
    icon: PropTypes.string.isRequired,
    iconVersion: PropTypes.string,
    identifier: PropTypes.string,
    label: PropTypes.string.isRequired,
    onPress: PropTypes.func,
    to: PropTypes.string
  })

  setup() {
    this.useStates({hover: false})
    this.textColor = (this.p.active || this.s.hover) ? activeColor : inactiveColor
  }

  render() {
    const {textColor} = this.tt
    const {active, icon, iconVersion, identifier, label, onPress, to} = this.p

    return (
      <View dataSet={this.cache("viewDataSet", {active, component: "chalky-layout/menu-item", identifier}, [active, identifier])}>
        <Link onPress={onPress} to={to}>
          <View
            onPointerLeave={this.tt.onPointerLeave}
            onPointerOver={this.tt.onPointerOver}
            style={this.iconAndTextViewStyle ||= {flexDirection: "row", alignItems: "center"}}
          >
            <View style={this.iconContainerViewStyle ||= {alignItems: "end", width: 14}}>
              <Icon name={icon} style={this.cache("iconStyle", {color: textColor}, [textColor])} version={iconVersion} />
            </View>
            <Text
              dataSet={this.textDataSet ||= {class: "menu-item-text"}}
              style={this.cache("textStyle", {
                marginLeft: 24,
                color: textColor,
                fontSize: 16
              }, [textColor])}
            >
              {label}
            </Text>
          </View>
        </Link>
      </View>
    )
  }

  onPointerLeave = () => this.setState({hover: false})
  onPointerOver = () => this.setState({hover: true})
}))
